import type { CountryInfo } from '../../types';
import type { AllCountriesResponse } from './api';

export const normalizeAllCountriesList = (list: AllCountriesResponse): CountryInfo[] => {
  if (!list) {
    return [];
  }
  return list;
};
